const RelatedList = require('module/user/related_list')
const Link = require('module/user/link')

const LinkList = RelatedList.extend({

    id: 'links',

    model: Link,

    comparator: 'display_order',

    initialize() {
        this.listenTo(this, 'change:display_order', this.sort)
    },

})

module.exports = LinkList
